import { makeAutoObservable } from 'mobx';
import apiConfig from '../api/routes';
import {
  AbsenceI, AbsenceListsForUserI, AbsenceListItemI,
  AbsentEmployeesT, ImageType, WhoisoffVersionType, AbsenceSettingsI
} from '../types';
import { downloadUserImage } from '../utils/functions';
import { DataNode } from 'antd/es/tree';

class Absence {
  constructor() {
    makeAutoObservable(this);
  }
  absenceList: AbsenceI = {
    absentEmployeesNumber: 0,
    leaveRequests: [],
    listName: ''
  };

  absenceListsForUser: AbsenceListsForUserI = {
    list: [],
  };
  images: ImageType[] = [];
  absentEmployees: AbsentEmployeesT = {
    absentEmployeesNumber: 0,
    leaveRequests: [
      {
        cancellationReason: '',
        categoryId: 0,
        categoryName: '',
        comment: '',
        countryCode: '',
        createdAt: '',
        duration: 0,
        employeeName: '',
        employeePosition: '',
        endDate: '',
        fileRequisites: [
          {
            description: '',
            id: 0,
            name: '',
            ref: ''
          }
        ],
        id: 0,
        isPossibleToCancel: false,
        isPostfactum: false,
        portraitUrl: '',
        requestName: '',
        requestTypeId: 0,
        source: '',
        startDate: '',
        status: '',
        type: '',
        userApproveRequestDto: {
          countryCode: '',
          countryName: '',
          email: '',
          firstNameAndLastNameWithSpace: '',
          firstname: '',
          id: 0,
          lastname: '',
          location: '',
          middlename: ''
        },
        userId: 0,
        warningMessages: [
          {
            level: '',
            message: ''
          }
        ]
      }
    ],
    listName: ''
  };
  isFetchedAbsenceImages = false;
  isFetchedAbsenceList = false;
  checkedNodes: DataNode[] = [];
  whoIsOffVersion: WhoisoffVersionType = 'VERSION_2';
  // absenceListsForUser: AbsenceListsForUserI = {
  //   list: [],
  // };
  isAbsenceSettingsFetched = false;
  absenceSettings: AbsenceSettingsI = {
    filtersList: [],
    filtersDivisionsTree: {
      listName: '',
      listType: '',
      plannerListId: -1,
      selected: false,
      subFilterDtos: [],
    },
    showLastTenEmployees: false,
    displayAllNewListsFromMyListCategory: false,
  };

  getAbsenceListsForUser = async () => {
    try {
      this.absenceListsForUser.list = await apiConfig.requestService.fetchAbsenceListsForUser();
    }
    catch (e) {
      this.absenceListsForUser.list.length = 0;
    }
  };

  setAbsenceListsForUser = async (body: AbsenceListItemI[]) => {
    let res;
    try {
      res = await apiConfig.requestService.setAbsenceListsForUser(body);
      if (res !== undefined) {
        this.absenceListsForUser.list = [...body];
      }
    }
    catch (e) {
      /* To add handling later if necessary */
    }
  };
  getPortraitUrl = async () => {
    const prepareLeaveRequestsImages = this.absentEmployees.leaveRequests.map(evt=>{
      return  downloadUserImage(evt.portraitUrl);
    });
    const prepareSpecialDaysImages = this.absentEmployees.specialDays?.map(evt=>{
      return  downloadUserImage(evt.portraitUrl);
    });
    const imagesResult = Promise.all(prepareSpecialDaysImages? [...prepareLeaveRequestsImages,...prepareSpecialDaysImages] : [...prepareLeaveRequestsImages]);
    try {
      this.isFetchedAbsenceImages = false;
      const res = await imagesResult;
      this.images = res.map(i => {
        return {originalUrl: i.imgUrl, blob: i.blob};
      });
      this.isFetchedAbsenceImages = true;
    }
    catch (e) {
      this.isFetchedAbsenceImages = false;
    }
  };

  setCheckedNodes = (data: DataNode[]) => {
    this.checkedNodes = data;
  };
  getAbsenceLists = async () => {
    try {
      this.isFetchedAbsenceList = false;
      this.absentEmployees = await apiConfig.requestService.fetchAbsenceLists();
      this.isFetchedAbsenceList = true;
    }
    catch (e) {
      this.isFetchedAbsenceList = false;
    }
  };

  setWhoIsOffVersion = (version: WhoisoffVersionType) => {
    this.whoIsOffVersion = version;
  };

  getAbsenceSettings = async () => {
    try {
      this.isAbsenceSettingsFetched = false;
      this.absenceSettings = await apiConfig.absenceSettingsService.getAbsenceSettings();
      this.isAbsenceSettingsFetched = true;
    }
    catch (e) {
      this.isAbsenceSettingsFetched = false;
    }
  };

  updateAbsenceSettings = async (
    myLists: AbsenceListItemI[],
    myLocations: AbsenceListItemI[],
    myDivisions: AbsenceListItemI[],
    showLastTenEmployees: boolean,
    displayAllNewListsFromMyListCategory: boolean,
    allCirclesListsChosen: boolean,
    allProjectListsChosen: boolean,
    allDivisionListsChosen: boolean,
    allPlannerListsChosen: boolean,
  ) => {
    const body = {
      blockOfFilters: [...myLists, ...myLocations, ...myDivisions],
      showLastTenEmployees: showLastTenEmployees,
      displayAllNewListsFromMyListCategory: displayAllNewListsFromMyListCategory,
      allCirclesListsChosen: allCirclesListsChosen,
      allProjectListsChosen: allProjectListsChosen,
      allDivisionListsChosen: allDivisionListsChosen,
      allPlannerListsChosen: allPlannerListsChosen
    };

    await apiConfig.absenceSettingsService.updateAbsenceSettings(body);
  };
}

export const AbsenceStore = new Absence();
